import LocalStorageService from 'web-app/services/local-storage';
import store from 'web-app/react/redux/store';
import {SELECTED_ACCOUNT_LOCAL_STORAGE_KEY} from 'web-app/react/login/constants';

export const setSelectedAccount = loginId => {
    if (loginId) {
        LocalStorageService.saveToLocalStorage(SELECTED_ACCOUNT_LOCAL_STORAGE_KEY, loginId);
    }
};

export const setLoggedInAccountAsSelected = () => {
    const loginId = store.getState().session.account.loginId;
    setSelectedAccount(loginId);
};
